import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject, Subject} from 'rxjs';

import {Product} from '../classes/product';
import {wishlistSelector} from 'src/app/core/selectors/selectors';
import {
    AddToCartAction,
    AddToWishListAction,
    ClearAllWishlistAction,
    RemoveFromWishListAction,
    UpdateWishListAction
} from 'src/app/core/actions/actions';
import {AuthenticationService} from './authentication.service';
import {ApiService} from './api.service';
import {User} from '../classes/app.models';

@Injectable({
    providedIn: 'root'
})

export class WishlistService {

    wishlist = [];
    wishlistStream: Subject<any> = new BehaviorSubject([]);
    wishlistQty: Subject<number> = new BehaviorSubject(0);
    private currentUser: User;

    constructor(private store: Store<any>, private toastrService: ToastrService,
                private authenticationService: AuthenticationService, private apiService: ApiService) {
        this.authenticationService.currentUser?.subscribe(x => this.currentUser = x);
        store.pipe(select(wishlistSelector)).subscribe(items => {
            this.wishlist = items;
            this.wishlistStream.next(items);
            this.wishlistQty.next(items.length);
        });
    }

    // Product add to Wishlist
    addToWishList(product, title = ''): void {
        this.authenticationService.currentUser?.subscribe(x => this.currentUser = x);
        this.apiService.addToWishListDB(JSON.stringify(product), title, this.currentUser?.customers_id).subscribe(data => {
            if (data['statusCode'] == 200) {
                this.store.dispatch(new AddToWishListAction({product}));
                this.toastrService.success('Your New Creation Is Completed. Please go ahead to share the same with your colleagues!');
            } else {
                this.toastrService.error('Media not added there is some issue');
            }
        });
    }

    updateToWishList(product, id = 0): void {
        this.apiService.updateToWishListDB(product, id, false).subscribe(data => {
            if (data['statusCode'] == 200) {
                this.store.dispatch(new UpdateWishListAction({product}));
                this.toastrService.success(product.type + ' added to Wishlist.');
            } else {
                this.toastrService.error('Media not added there is some issue');
            }
        });
    }

    // Product removed from Wishlist
    removeFromWishList(product): void {
        this.store.dispatch(new RemoveFromWishListAction({product}));
        this.toastrService.success('Media removed from Wishlist.');
    }

    // Product moved from Wishlist to Cart
    moveToCart(product): void {
        this.store.dispatch(new RemoveFromWishListAction({product}));
        this.store.dispatch(new AddToCartAction({product, qty: 1}));
        this.toastrService.success('Media moved to Cart.');
    }

    // Check whether product is in Wishlist or not
    isInWishlist(product: Product): boolean {
        return this.wishlist.find(item => item.id == product.id) ? true : false;
    }

    // Product Add to Cart
    clearAllWishlist() {
        this.store.dispatch(new ClearAllWishlistAction({}));
    }
}
